export function selectTab(tabId) {
  return {
    type: 'TAB_SELECTED',
    payload: tabId,
  };
}

export function showTabs(...tabIds) {
  const tabsToShow = {};
  tabIds.forEach(e => tabsToShow[e] = true);
  return {
    type: 'TAB_SHOWED',
    payload: tabsToShow,
  };
}



// WEBPACK FOOTER //
// ./src/lib_react_adminlte/template/tab/tabActions.js